import { render } from "./NavPlantTypesSidebar.vue?vue&type=template&id=3b825505"
import script from "./NavPlantTypesSidebar.vue?vue&type=script&lang=js"
export * from "./NavPlantTypesSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__